import { observer } from "mobx-react-lite";
import SmartAppStep from "../../components/apps/SmartAppStep";
import SmartAppBase from "../../components/apps/SmartAppBase";
import { RunAI } from "e.sic-platform.webclient/src/components/svg/svgImageList";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';
import ExportButton from "../../components/buttons/app-action-buttons/ExportButton";
import { analysisApp } from "../../services/apps/SmartApps";
import VideoAnalysisPlayerSection from "./components/VideoAnalysisPlayerSection";
import  VideoAnalysisDiagramSection  from "./components/VideoAnalysisDiagramSection";

export default observer(function VideoAnalysisPage() {
  const videoAnalysis = analysisApp.services.videoAnalysis!;
  const {themeClass} = useThemeService();

  if (videoAnalysis.analysisSuccessful) analysisApp.setStep(3);

  return (
    <SmartAppBase 
      appStorage={analysisApp}
      icon={{
        svg: RunAI,
        textKey: "RunVideoAnalysisButton.run",
        className: themeClass(["icon-custom"]),
      }}
      actionBar={<ExportButton exportVideoAnalaysis={videoAnalysis.exportVideoAnalysis} disabled={!videoAnalysis.analysisSuccessful || videoAnalysis.isLoading}/>}
    >
      <SmartAppStep
        titleKey="videoAnalysis.viewVideo.title"
        descriptionKey="videoAnalysis.viewVideo.description"
        visible={videoAnalysis.video !== undefined}
        step={2}
        appStorage={analysisApp}
      >
        <VideoAnalysisPlayerSection videoAnalysis={videoAnalysis}  />
      </SmartAppStep>
      <SmartAppStep
        titleKey="videoAnalysis.analysis.title"
        descriptionKey="videoAnalysis.analysis.description"
        visible={
          videoAnalysis.video !== undefined && videoAnalysis.video.isConverted
        }
        step={3}
        appStorage={analysisApp}
      >
        <VideoAnalysisDiagramSection videoAnalysis={videoAnalysis} />
      </SmartAppStep>
    </SmartAppBase>
  );
});
